<template>
    <svg viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M37.5999 60.1C49.695 60.1 59.5 50.2951 59.5 38.2001C59.5 26.105 49.695 16.3 37.5999 16.3C25.5049 16.3 15.7 26.105 15.7 38.2001C15.7 50.2951 25.5049 60.1 37.5999 60.1Z" fill="currentColor" stroke="currentColor" stroke-width="3" stroke-miterlimit="10"/>
        <path d="M37.6001 64.4V75.8" stroke="currentColor" stroke-width="4"/>
        <path d="M37.6001 0.199951V11.9" stroke="currentColor" stroke-width="4"/>
        <path d="M0 38.2H11.3" stroke="currentColor" stroke-width="4"/>
        <path d="M11 11.6L19 19.6" stroke="currentColor" stroke-width="4"/>
        <path d="M11 64.8L19 56.7" stroke="currentColor" stroke-width="4"/>
        <path d="M75.2 38.4H63.8" stroke="currentColor" stroke-width="4"/>
        <path d="M64.2001 11.8L56.1001 19.8" stroke="currentColor" stroke-width="4"/>
        <path d="M64.2001 65L56.1001 56.9" stroke="currentColor" stroke-width="4"/>
    </svg>
<!--    <svg viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--        <path d="M37.5999 60.1C49.695 60.1 59.5 50.2951 59.5 38.2001C59.5 26.105 49.695 16.3 37.5999 16.3C25.5049 16.3 15.7 26.105 15.7 38.2001C15.7 50.2951 25.5049 60.1 37.5999 60.1Z"-->
<!--              fill="currentColor" stroke="currentColor" stroke-width="3" stroke-miterlimit="10"/>-->
<!--    </svg>-->
</template>

<script>
    export default {
        name: "SVGSunBlack"
    }
</script>

<style scoped>

</style>
